import clsx from 'clsx'
import './table.scss'
import { LegacyRef, ReactNode } from 'react'
import { TableLoadingIndicator } from '@/shared/ui/loading-indicator/LoadingIndicator'

interface TableProps {
    isLoading: boolean
    thead: ReactNode
    tbody: ReactNode
    className?: string
    baseTableClassName?: string
    wrapperClassName?: string
    tableContainerRef?: LegacyRef<HTMLDivElement>
}

export const Table = ({
    isLoading,
    thead,
    tbody,
    className,
    baseTableClassName,
    wrapperClassName,
    tableContainerRef,
}: TableProps) => {
    return (
        <div
            ref={tableContainerRef}
            className={clsx('base-table', baseTableClassName)}
        >
            {isLoading && <TableLoadingIndicator />}
            <div className="table-container">
                <div className={clsx('table-wrapper', wrapperClassName)}>
                    <table className={className}>
                        <thead>{thead}</thead>
                        <tbody>{tbody}</tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
